import { StringHelpers } from "../../helpers/StringHelpers";
import { IFormConfig } from "../../interfaces/FormConfig";

export class FormConfigHelper {

  public static MergeConfigs(target: IFormConfig, source: IFormConfig) {
    if (source.thanksPageUrl !== undefined) {
      target.thanksPageUrl = source.thanksPageUrl;
    }

    if (source.kenticoFormName !== undefined) {
      target.kenticoFormName = source.kenticoFormName;
    }

    if (source.submitButtonCaption !== undefined) {
      target.submitButtonCaption = source.submitButtonCaption;
    }
    if (source.LogoutPopupTitle !== undefined) {
      target.LogoutPopupTitle = source.LogoutPopupTitle;
    }
    if (source.LogoutPopupDescription !== undefined) {
      target.LogoutPopupDescription = source.LogoutPopupDescription;
    }
    if (source.noAutoGenerateSummary !== undefined && !target.overrideNoAutoGenerateSummary) {
      target.noAutoGenerateSummary = source.noAutoGenerateSummary;
    }
    if (source.popupOK !== undefined) {
      target.popupOK = source.popupOK;
    }
    if (source.onSuccessPopupMessage !== undefined) {
      target.onSuccessPopupMessage = source.onSuccessPopupMessage;
    }
    if (source.onSuccessPopupDescription !== undefined) {
      target.onSuccessPopupDescription = source.onSuccessPopupDescription;
    }
    
    if (source.PopupErrorMessageTitle !== undefined) {
      target.PopupErrorMessageTitle = source.PopupErrorMessageTitle;
    }
    if (source.PopupErrorMessageDescription !== undefined) {            
      target.PopupErrorMessageDescription = StringHelpers.parseHtmlEncodedString(source.PopupErrorMessageDescription);
    }
    if (source.PopupErrorMessagePhoneNumber !== undefined) {
      target.PopupErrorMessagePhoneNumber = source.PopupErrorMessagePhoneNumber;
    }
    if (source.PopupErrorMessagePhoneNumberInfo !== undefined) {
      target.PopupErrorMessagePhoneNumberInfo = source.PopupErrorMessagePhoneNumberInfo;
    }
    if (source.PopupErrorMessageButtonText !== undefined) {
      target.PopupErrorMessageButtonText = source.PopupErrorMessageButtonText;
    }
    if (source.PopupErrorMessageEmailInfo !== undefined) {
      target.PopupErrorMessageEmailInfo = source.PopupErrorMessageEmailInfo;
    }
    if (source.PopupErrorMessageEmail !== undefined) {
      target.PopupErrorMessageEmail = source.PopupErrorMessageEmail;
    }
  }
}